'use strict';

angular.module('ClinicApp').directive('progressBar', function() {
  return {
    templateUrl: '/views/directives/_progress-bar.html',
    scope: {
      value: '=progressBar', // Expects a value between 0 and 1
      mini: '=',
      tooltipText: '=',
    },
    link: function(scope, _element, _$attrs, _ngModel) {
      scope.$watch('value', function() {
        scope.widthPercentage = scope.value * 95 + 5 + '%'; // Min value should be 5 so that there is always part visible
        if (scope.value === 0) {
          scope.colorClass = 'text-danger';
          scope.bgClass = 'progress-bar-danger';
        } else {
          scope.colorClass = 'text-teal';
          scope.bgClass = 'progress-bar-success';
        }
      });
    },
  };
});
